import React from 'react'
import s from '../CreateQuiz.module.scss'

export const EmptyContent = () => {
    return (
        <>
            <div className={`${s.quizCreationContainer}`}>
                <div>
                    <h2 className="mb-5">Add your questions</h2>
                    <div>Start creating your quiz by adding your first question.</div>
                    <div>You need at least two questions in your quiz.</div>
                </div>
            </div>
        </>
    )
}
